import { FileType, ProjectFile } from 'services/file.service';
import { useAppSelector, useAppDispatch } from 'store/store-hooks';
import { getVideoUrl } from 'components/app/_helpers/_app.helper';
import { uploadFilePoster } from 'components/app/_mediator/app-files.slice';
import { PlayerFrame } from 'components/app/app-components/frame-generator/frame-generator.helper';

import { FrameGeneratorVideo } from 'components/app/app-components/frame-generator/frame-generator-video';
import { FrameGeneratorImage } from 'components/app/app-components/frame-generator/frame-generator-image';

interface Props {
  file: ProjectFile;
}

export const SelectorFilesCover = ({ file }: Props) => {
  const selectedProject = useAppSelector((state) => state.projects.selectedProject);
  const posters = useAppSelector((state) => state.app__files.posters);
  const dispatch = useAppDispatch();

  const handleFrame = (frame: PlayerFrame) => {
    if (!selectedProject) return;
    dispatch(
      uploadFilePoster({
        projectId: selectedProject,
        blob: frame.blob,
        fileId: file.id,
      })
    );
  };

  if (posters[file.id]) return <img src={posters[file.id]!} crossOrigin="anonymous" />;
  if (file.fileType === FileType.image) return <FrameGeneratorImage url={getVideoUrl(file)} cb={handleFrame} />;
  return <FrameGeneratorVideo cb={handleFrame} url={getVideoUrl(file)} />;
};
